import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { generateUrl, getTeamSlugById } from '@fede/utils';
import LoginMenu from './LoginMenu';
import LoggedIn from './LoggedIn';
import LoggedOut from './LoggedOut';
var defaultSetFieldPassOpen = function defaultSetFieldPassOpen() {};
var Button = function Button(_ref) {
  var clubId = _ref.clubId,
    isClub = _ref.isClub,
    isFieldPassOpen = _ref.isFieldPassOpen,
    isLoggedIn = _ref.isLoggedIn,
    isMlbtvNav = _ref.isMlbtvNav,
    locale = _ref.locale,
    onLogout = _ref.onLogout,
    _ref$setFieldPassOpen = _ref.setFieldPassOpen,
    setFieldPassOpen = _ref$setFieldPassOpen === void 0 ? defaultSetFieldPassOpen : _ref$setFieldPassOpen,
    useFieldPass = _ref.useFieldPass,
    useInlineLogout = _ref.useInlineLogout;
  var buttonEl = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoginMenuOpen = _useState2[0],
    setIsLoginMenuOpen = _useState2[1];
  var isBrowser = typeof window !== 'undefined';
  var isSpanish = locale === 'es';
  var loggedInFallback = isSpanish ? 'Cuenta' : 'Account';
  var loggedOutFallback = isSpanish ? 'Iniciar sesión' : 'Log in';
  var _ref2 = isBrowser && window.i18n_dictionary || {},
    _ref2$navigation_acco = _ref2.navigation_account,
    navigation_account = _ref2$navigation_acco === void 0 ? loggedInFallback : _ref2$navigation_acco,
    _ref2$navigation_sign = _ref2.navigation_sign_in,
    navigation_sign_in = _ref2$navigation_sign === void 0 ? loggedOutFallback : _ref2$navigation_sign;
  var loggedInAria = navigation_account;
  var loggedOutAria = navigation_sign_in;
  var redirectUrl = generateUrl({
    basePath: 'login',
    clubPath: isClub && getTeamSlugById(parseInt(clubId, 10)),
    lang: locale,
    rootRelative: true
  });
  var loginRedirect = function loginRedirect() {
    if (isMlbtvNav) {
      // we can't use redirectToLogin() here becuase we're passing the campaignCode url param
      // at least not until we get a fix into mlb-okta
      var origin = window.location.origin;
      var campaignCode = 'campaignCode=mp5';
      var redirectUri = 'redirectUri=/tv';
      window.location.href = "".concat(origin, "/login?").concat(campaignCode, "&").concat(redirectUri);
    } else {
      window.mlbOkta.redirectToLogin(redirectUrl);
    }
  };
  var handleClick = function handleClick() {
    if (isLoggedIn) {
      setIsLoginMenuOpen(!isLoginMenuOpen);
    } else {
      setTimeout(function () {
        if (isBrowser) {
          if (window.mlbOkta) {
            if (useFieldPass) {
              setFieldPassOpen(true);
            } else {
              loginRedirect();
            }
          } else {
            window.location = "".concat(redirectUrl, "?redirectUri=").concat(window.location.pathname);
          }
        }
      }, 300);
    }
  };
  var handleKeyDown = function handleKeyDown(event) {
    var keyCode = event.keyCode;
    var enter = keyCode === 13;
    var leftArrow = keyCode === 37;
    var downArrow = keyCode === 40;
    if (leftArrow) {
      var nextElement;
      var navNodes = document.querySelectorAll('.header__nav-top__nav-item:not(.header__nav-top__nav-item--hidden), .header__nav-top__nav-search');
      if (navNodes && navNodes.length) {
        nextElement = navNodes[navNodes.length - 1];
      }
      if (nextElement) {
        nextElement.focus();
      }
      if (isLoginMenuOpen) {
        handleClick();
      }
    } else if (downArrow || enter) {
      // disable page scrolling
      if (downArrow) {
        event.preventDefault();
      }
      if (isLoginMenuOpen) {
        document.querySelector('.mlb-header__login-menu__link').focus();
      } else {
        handleClick();
      }
    }
  };
  var handleMouseEnter = function handleMouseEnter() {
    var isMobile = isBrowser && window.innerWidth < 1024;
    if (isLoggedIn && !isMobile) {
      setIsLoginMenuOpen(true);
    }
  };
  var handleMouseLeave = function handleMouseLeave() {
    if (isLoggedIn) {
      setIsLoginMenuOpen(false);
    }
  };
  var getLogInAriaPopup = function getLogInAriaPopup(_ref3) {
    var isLoggedIn = _ref3.isLoggedIn,
      useFieldPass = _ref3.useFieldPass;
    if (isLoggedIn) {
      return true;
    } else if (useFieldPass) {
      return 'dialog';
    } else {
      return false;
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "header__nav-top__login-container",
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave
  }, /*#__PURE__*/React.createElement("button", {
    className: cx({
      'header__nav-top__button account': true,
      'account--logged-in': isLoggedIn,
      active: isLoginMenuOpen
    }),
    onClick: handleClick,
    onKeyDown: handleKeyDown,
    ref: buttonEl,
    "aria-haspopup": getLogInAriaPopup({
      isLoggedIn: isLoggedIn,
      useFieldPass: useFieldPass
    }),
    "aria-label": isLoggedIn ? loggedInAria : loggedOutAria,
    "aria-expanded": isLoginMenuOpen || isFieldPassOpen,
    "data-testid": "header-profile-button"
  }, /*#__PURE__*/React.createElement("span", {
    className: "header__nav-top__nav-item__text"
  }, isLoggedIn ? navigation_account : navigation_sign_in), isLoggedIn ? /*#__PURE__*/React.createElement(LoggedIn, {
    className: "p-icon p-icon--login icon",
    "aria-hidden": true
  }) : /*#__PURE__*/React.createElement(LoggedOut, {
    className: "p-icon p-icon--login icon",
    "aria-hidden": true
  })), isLoggedIn && /*#__PURE__*/React.createElement(LoginMenu, {
    clubId: clubId,
    isClub: isClub,
    isLoginMenuOpen: isLoginMenuOpen,
    locale: locale,
    mouseLeaveHandler: handleMouseLeave,
    onLogout: onLogout,
    useInlineLogout: useInlineLogout
  }));
};
export default Button;
Button.propTypes = {
  clubId: PropTypes.string,
  isClub: PropTypes.bool,
  isFieldPassOpen: PropTypes.bool,
  isLoggedIn: PropTypes.bool,
  isMlbtvNav: PropTypes.bool,
  locale: PropTypes.string,
  onLogout: PropTypes.func,
  setFieldPassOpen: PropTypes.func,
  useFieldPass: PropTypes.bool,
  useInlineLogout: PropTypes.bool
};